<!--3. ProductBreadcrumb.vue -->
<template>
    <nav class="breadcrumb-nav">
        <div class="product-header">
            <h1 class="product-title">{{ product.name }}</h1>
        </div>

        <div v-if="product.category" class="breadcrumb">
            <span @click="$emit('show-similar')" class="active">
                {{ product.category?.parent_category?.name }}
            </span>
            <span v-if="product.category?.parent_category?.name && product.category.name" class="separator">/</span>
            <span @click="$emit('show-similar-childs')" class="active">
                {{ product.category.name }}
            </span>
        </div>

        <div class="breadcrumb">
            <span>{{ $t('sentence.addedDate') }} {{ formatDate(product.validated) }}</span>
        </div>

        <div>
            <button type="button" class="btn text-secondary" @click="openReportModal">
                {{ $t('sentence.report_ad') }}
                <span class="mdi mdi-bug"></span>
            </button>
        </div>
        <!-- Report Product Modal -->
        <div class="modal fade show" v-if="showReportModal" style="display:block" tabindex="-1" role="dialog"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ $t('sentence.report_ad') }}
                        </h5>
                        <button type="button" class="close" @click="closeReportModal">
                            <span>&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <!-- Reason -->
                        <div class="form-group">
                            <label>{{ $t('attr.reason') }} *</label>
                            <select v-model="reportForm.reason" class="form-control" required>
                                <option disabled value="">
                                    {{ $t('sentence.chooseOption') }}
                                </option>
                                <option value="spam">{{ $t('report.spam') }}</option>
                                <option value="fake">{{ $t('report.fake') }}</option>
                                <option value="illegal">{{ $t('report.illegal') }}</option>
                                <option value="offensive">{{ $t('report.offensive') }}</option>
                                <option value="misleading">{{ $t('report.misleading') }}</option>
                            </select>
                        </div>

                        <!-- Message -->
                        <div class="form-group">
                            <label>{{ $t('attr.message') }}</label>
                            <textarea v-model="reportForm.message" class="form-control" rows="4"
                                :placeholder="$t('sentence.optionalMessage')"></textarea>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeReportModal">
                            {{ $t('action.cancel') }}
                        </button>
                        <button type="button" class="btn btn-danger" :disabled="reportLoading" @click="submitReport">
                            <span v-if="reportLoading" class="spinner-border spinner-border-sm"></span>
                            {{ $t('action.submit') }}
                        </button>
                    </div>

                </div>
            </div>
        </div>

    </nav>
</template>

<script>
import helper from "@/services/helper";

export default {
    name: 'ProductBreadcrumb',
    data() {
        return {
            showReportModal: false,
            reportLoading: false,
            reportForm: {
                product_id: null,
                reason: '',
                message: ''
            }
        }
    }
    ,
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatDate: helper.formatDate,

        openReportModal() {
            this.reportForm.product_id=this.product.id
            this.reportForm.reason=''
            this.reportForm.message=''
            this.showReportModal=true
        },

        closeReportModal() {
            this.showReportModal=false
        },

        async submitReport() {
            if (!this.reportForm.reason) {
                this.$notify({
                    group: 'error',
                    title: this.$t('sentence.validationError'),
                    text: this.$t('sentence.chooseOption')
                })
                return
            }

            try {
                this.reportLoading=true

                const res=await this.$axios.post(
                    '/product-reports',
                    this.reportForm
                )

                this.$notify({
                    group: 'success',
                    title: res.data.message||this.$t('sentence.reportSent')
                })

                this.closeReportModal()
            } catch (err) {
                this.$notify({
                    group: 'error',
                    title: err.response?.data?.message||this.$t('sentence.errorSaving')
                })
            } finally {
                this.reportLoading=false
            }
        }
    }

};
</script>
<style scoped>
.breadcrumb-nav {
    background: white;
    padding: 15px 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.product-header {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid var(--gray-100);
}

.product-title {
    font-size: 24px;
    font-weight: 700;
    color: var(--color-3);
    margin-bottom: 10px;
    line-height: 1.3;
}

.breadcrumb {
    font-size: 14px;
    color: var(--color-6);
}

.breadcrumb .separator {
    margin: 0 8px;
}

.breadcrumb .active {
    color: var(--color-3);
    font-weight: 600;
    cursor: pointer;
}


@media (max-width: 768px) {
    .product-title {
        font-size: 20px;
    }
}

@media (max-width: 576px) {
    .breadcrumb-nav {
        padding: 15px 15px;
    }

    .product-title {
        font-size: 18px;
    }
}
</style>